import React, { Component } from 'react';
import { ContentCard, IndexGrid } from '@rockerbox/styleguide'

const ModelSetups = ({featureHeaders, featureData}) => (
  <ContentCard hasTable title="Model Run Details" borderless>
    <IndexGrid data={featureData} cols={featureHeaders} as={ContentCard.Table} />
  </ContentCard>
)
export default ModelSetups;
